var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.35 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 139.35,
    height: 256,
    rx: 15.69,
    ry: 15.69,
    style: {
      stroke: "#c4c4c4",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.03,
    y: 217.31,
    width: 113.29,
    height: 27.07,
    rx: 6.56,
    ry: 6.56,
    style: {
      fill: "#cecece",
      opacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.04,
    y: 221.6,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.47,
    y: 221.6,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#42d551"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.15,
    y: 221.6,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#1fb9f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.08,
    y: 221.6,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#42d551"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.47,
    y: 152.55,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#525252"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.15,
    y: 152.55,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#feda4c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.08,
    y: 152.55,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.04,
    y: 122.36,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#fc7709"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.47,
    y: 122.36,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#1e9ff8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.15,
    y: 122.36,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#c82cc2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.08,
    y: 122.36,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#42ccd3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.04,
    y: 93.16,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#525252"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.47,
    y: 93.16,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#e44e4a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.15,
    y: 93.16,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.08,
    y: 93.16,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#feda4c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.04,
    y: 63.96,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#4bcae6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.47,
    y: 63.96,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#c7af8f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.15,
    y: 63.96,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#525252"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.08,
    y: 63.96,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#1e9ff8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.04,
    y: 34.77,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#848484"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.47,
    y: 34.77,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#d38edf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.15,
    y: 34.77,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.08,
    y: 34.77,
    width: 18.24,
    height: 18.24,
    rx: 4.36,
    ry: 4.36,
    style: {
      fill: "#42d551"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.66,
    y: 16.18,
    width: 24.03,
    height: 6.27,
    rx: 3.13,
    ry: 3.13,
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.44,
    y: 16.18,
    width: 6.27,
    height: 6.27,
    rx: 3.13,
    ry: 3.13,
    style: {
      fill: "#212121"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b4c96019fe1e891700ef5f7d224bd8d9.svg";
export { ForwardRef as ReactComponent };